import { NgModule} from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Screenshot } from '@ionic-native/screenshot/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { DirectivesModule } from './directives/directives.module';
import { Base64 } from '@ionic-native/base64/ngx';
import { TimeoutInterceptorService } from './interceptor/timeout-interceptor.service';
import { AppVersion } from '@ionic-native/app-version/ngx';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule,
    IonicModule.forRoot(),
    DirectivesModule,
    AppRoutingModule,
    HttpClientModule,
    HammerModule,
    JwtModule.forRoot(
        {
          config: {
            tokenGetter: () => {
              return window.localStorage.getItem('token');
              }
          }
        })
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Screenshot,
    SocialSharing,
    Base64,
    AppVersion,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
